import React, { useState, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { language } from "../../stores/slices/languageSlice";
import { UserContext } from "../../stores/Context/Context";
import Input from "../input/Input";
import validateInput from "../../utilities/validations/validateInput";
import DateInput from "../input/Date";
import { toast } from "react-toastify";
import { lookUp } from "../../stores/slices/lookupSlice";
import AutoSuggest from "../input/autoSuggest";
import { insuranceInfoData } from "../../stores/slices/patientSearch/patientSearchSlice";

function Insurance() {
  let wizardValidation = useContext(UserContext);
  const selectedLanguage = useSelector(language).Appintake.insurance;
  const errorMessage = useSelector(language).errorMessage
  const preQualData = useSelector((state) => state.preQualValidateSlice.success.preQualData)
  const patientInformation = useSelector((state) => state.patientSearchSlice.insurance);
  const program = useSelector((state) => state.patientSearchSlice.patientInformation.Program)
  const lookUpData = useSelector(lookUp);
  const [insuranceInfo, setInsuranceInfo] = useState({
    primaryInsurance: { value: "", isValid: true, isOther: false },
    planType: { value: "", isValid: true },
    policyID: { value: "", isValid: true },
    insuranceType: { value: "", isValid: true },
    phoneNumber: { value: "", isValid: true,errorMsg:false },
    subscriberName: { value: "", isValid: true },
    groupNumber: { value: "", isValid: true },
    DOB: { value: "", isValid: true },
    medicareSupplement: { checked: false },
    secondaryInsurance: { checked: false },
    medicarePart: { checked: false },
    isSecondaryInsurance: { value: "", isValid: true, isOther: false }
  });


  useEffect(() => {
    setInsuranceInfo({
      ...patientInformation,
      insuranceType: {
        value: preQualData.insuranceType,
        isValid: true,
      },

    })
  }, [])


  const dispatch = useDispatch()
  //Overall Insurance Validation
  function insuranceValidation() {
    if ((preQualData.insuranceType == '' || program == 'FAF' || (program == 'CPR' && preQualData.fundGroup == "Travel"))) {
      return true
    } else {
      const isValidPolicy = insuranceInfo.primaryInsurance.value != "" && insuranceInfo.primaryInsurance.isValid && insuranceInfo.planType.value != "" && insuranceInfo.planType.isValid && insuranceInfo.insuranceType.value != "" && insuranceInfo.insuranceType.isValid
      // const isValidPolicy = insuranceInfo.primaryInsurance.value != "" && insuranceInfo.primaryInsurance.isValid && insuranceInfo.planType.value != "" && insuranceInfo.planType.isValid && insuranceInfo.policyID.value != "" && insuranceInfo.policyID.isValid && insuranceInfo.insuranceType.value != "" && insuranceInfo.insuranceType.isValid && insuranceInfo.phoneNumber.value != "" && insuranceInfo.phoneNumber.isValid
      // const isValidSubscriber = insuranceInfo.subscriberName.value != "" && insuranceInfo.subscriberName.isValid && insuranceInfo.DOB.value != "" && insuranceInfo.DOB.isValid
      const isValidSubscriber = true
      const isValidSecondaryInsurance = insuranceInfo.secondaryInsurance.checked ? (insuranceInfo.isSecondaryInsurance.value != "" && insuranceInfo.isSecondaryInsurance.isValid) : true
      if (isValidPolicy && isValidSubscriber && isValidSecondaryInsurance) {
        dispatch(insuranceInfoData(insuranceInfo))
        return true
      } else {
        toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
        setInsuranceInfo((prevState) => ({
          ...prevState,
          primaryInsurance: {
            value: insuranceInfo.primaryInsurance.value,
            isValid: insuranceInfo.primaryInsurance.value != "" && insuranceInfo.primaryInsurance.isValid
          },
          planType: {
            value: insuranceInfo.planType.value,
            isValid: insuranceInfo.planType.value != "" && insuranceInfo.planType.isValid
          },
          policyID: {
            value: insuranceInfo.policyID.value,
            isValid: insuranceInfo.policyID.value != "" && insuranceInfo.policyID.isValid
          },
          insuranceType: {
            value: insuranceInfo.insuranceType.value,
            isValid: insuranceInfo.insuranceType.value != "" && insuranceInfo.insuranceType.isValid
          },
          phoneNumber: {
            value: insuranceInfo.phoneNumber.value,
            isValid: insuranceInfo.phoneNumber.value != "" && insuranceInfo.phoneNumber.isValid
          },
          subscriberName: {
            value: insuranceInfo.subscriberName.value,
            isValid: insuranceInfo.subscriberName.value != "" && insuranceInfo.subscriberName.isValid
          },
          DOB: {
            value: insuranceInfo.DOB.value,
            isValid: insuranceInfo.DOB.value != "" && insuranceInfo.DOB.isValid
          },
          isSecondaryInsurance: {
            value: insuranceInfo.isSecondaryInsurance.value,
            isValid: insuranceInfo.secondaryInsurance.checked ? (insuranceInfo.isSecondaryInsurance.value != "" && insuranceInfo.isSecondaryInsurance.isValid) : insuranceInfo.isSecondaryInsurance.isValid
          },
        }))
      }
    }
  }
  wizardValidation.formValidation.isValidate = insuranceValidation

  //insurance Field Validation
  const inputOnChange = (e, fieldvalidation) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);
    if (name == "medicarePart" || name == "secondaryInsurance" || name == "medicareSupplement") {
      setInsuranceInfo((prevState) => ({
        ...prevState,
        [name]: {
          checked: e.target.checked
        },
      }))
    }else if(name == "phoneNumber"){
      setInsuranceInfo((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
          errorMsg:inputValidate.errorMsg
        },
      }))

    }else {
      setInsuranceInfo((prevState) => ({
        ...prevState,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
      }))
    }
  }

  const onChangeField = (name, value, selected) => {
    setInsuranceInfo((prevState) => ({
      ...prevState,
      [name]: {
        value: value,
        isValid: value.length > 0,
        isOther: selected
      }
    }))
  }



  // If patient does not have any insurance carrier
  //TODO: Replace true with condition to check for insurance carrier of patient
  if (preQualData.insuranceType == '' || program == 'FAF' || (program == 'CPR' && preQualData.fundGroup == "Travel")) {
    return (
      <>
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3 mt-4">
          <p className="p-1 ps-3 text-theme-1 fs-base fw-medium">
            {selectedLanguage.primaryInsurancecarrier}
          </p>
        </div>
        <p className="p-1 ps-3 fs-sm fw-medium">
          {selectedLanguage.healthInsurance}
        </p>
        <span className="p-1 ps-3">{preQualData.insuranceType == '' ? 'No' : 'Yes'}</span>
        {preQualData.insuranceType != '' && <React.Fragment><p className="p-1 ps-3 fs-sm fw-medium">
          {selectedLanguage.insuranceType}
        </p>
          <span className="p-1 ps-3">{preQualData.insuranceType == '' ? '--' : preQualData.insuranceType}</span> </React.Fragment>}
      </>
    );
  }

  //If patient has primary insurance carrier
  return (
    <React.Fragment>
      <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
          <i data-feather="home"></i>
          <p className="p-1 ps-3 text-theme-1">
            {selectedLanguage.policyDetails.heading}
          </p>
        </div>

        <AutoSuggest
          name="primaryInsurance"
          label={selectedLanguage.policyDetails.primaryInsurance}
          value={patientInformation.primaryInsurance.value}
          elementConfig={lookUpData.insuranceCarrierName}
          isValid={insuranceInfo.primaryInsurance.isValid}
          errorMsg={errorMessage?.inputErrorMessage}
          onChangeField={onChangeField}
          Maxlength='200'
        />
        <Input
          type="select"
          id="planType"
          label={selectedLanguage.policyDetails.planType}
          name="planType"
          value={insuranceInfo.planType.value}
          isValid={insuranceInfo.planType.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          elmentconfig={lookUpData.insurancePlanType}
          maxLength="100"
        />
        {/* <Input
          type="text"
          id="policyID"
          label={selectedLanguage.policyDetails.policyID}
          name="policyID"
          value={insuranceInfo.policyID.value}
          onChange={(e) => inputOnChange(e, "numberString")}
          isValid={insuranceInfo.policyID.isValid}
          maxLength="100"
          errorMsg={errorMessage?.inputErrorMessage}
        /> */}
        <Input
          type="text"
          id="insuranceType"
          label={selectedLanguage.policyDetails.insuranceType}
          name="insuranceType"
          value={insuranceInfo.insuranceType.value}
          isValid={insuranceInfo.insuranceType.isValid}
          onChange={(e) => inputOnChange(e, "dropDown")}
          errorMsg={errorMessage?.inputErrorMessage}
          disabled={true}
          maxLength="100"
        />
        {/* <Input
          type="text"
          id="phoneNumber"
          label={selectedLanguage.policyDetails.telephoneNumber}
          name="phoneNumber"
          value={insuranceInfo.phoneNumber.value}
          onChange={(e) => inputOnChange(e, "phoneNumber")}
          isValid={insuranceInfo.phoneNumber.isValid}
          maxLength="12"
          errorMsg={insuranceInfo.phoneNumber.errorMsg  ?  "Phone/Fax number cannot begin with the number one" : errorMessage?.inputErrorMessage}
        /> */}
      </div>
      {/* <div className="grid columns-12 gap-4 gap-y-5 mt-5 p-8 mb-5">
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
          <i data-feather="home"></i>
          <p className="p-1 ps-3 text-theme-1">
            {selectedLanguage.subscriberDetails.heading}
          </p>
        </div>
        <Input
          type="text"
          id="subscriberName"
          label={selectedLanguage.subscriberDetails.subscriberName}
          name="subscriberName"
          value={insuranceInfo.subscriberName.value}
          onChange={(e) => inputOnChange(e, "subscriberName")}
          isValid={insuranceInfo.subscriberName.isValid}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="90"
        />
        <Input
          type="text"
          id="groupNumber"
          label={selectedLanguage.subscriberDetails.groupNumber}
          name="groupNumber"
          value={insuranceInfo.groupNumber.value}
          onChange={(e) => inputOnChange(e, "numberStringGroupNumber")}
          isValid={insuranceInfo.groupNumber.isValid}
          errorMsg={errorMessage?.inputErrorMessage}
          maxLength="100"
        />
        <DateInput
          id="DOB"
          name="DOB"
          label={selectedLanguage.subscriberDetails.DOB}
          value={insuranceInfo.DOB.value}
          isValid={insuranceInfo.DOB.isValid}
          errorMsg={errorMessage.inputErrorMessage}
          onChange={(e) => inputOnChange(e, 'dob')}
        />
      </div> */}
      <div className="mt-5 p-8 mb-5">
        <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
          <i data-feather="home"></i>
          <p className="p-1 ps-3 text-theme-1">
            {selectedLanguage.insuranceInformation.heading}
          </p>
        </div>
        {/* <Input
          type="switch1"
          id="medicareSupplement"
          labelPosition="left"
          name="medicareSupplement"
          label={selectedLanguage.insuranceInformation.medicareSupplement}
          value={insuranceInfo.medicareSupplement.checked}
          onClick={(e) => inputOnChange(e)}
        /> */}
        <Input
          type="switch1"
          id="secondaryInsurance"
          labelPosition="left"
          name="secondaryInsurance"
          label={selectedLanguage.insuranceInformation.secondaryInsurance}
          value={insuranceInfo.secondaryInsurance.checked}
          onClick={(e) => inputOnChange(e)}
        />
        {/* <Input
          type="switch1"
          id="medicarePart"
          labelPosition="left"
          name="medicarePart"
          label={selectedLanguage.insuranceInformation.medicarePart}
          value={insuranceInfo.medicarePart.checked}
          onClick={(e) => inputOnChange(e)}
        /> */}
        {insuranceInfo.secondaryInsurance.checked && <div className="d-flex justify-content-center">
          <p className="py-8">{selectedLanguage.insuranceInformation.insuranceCarrier}</p>
          <AutoSuggest
            name="isSecondaryInsurance"
            label={selectedLanguage.insuranceInformation.isSecondaryInsurance}
            value={insuranceInfo.isSecondaryInsurance.value}
            elementConfig={lookUpData.insuranceCarrierName}
            isValid={insuranceInfo.isSecondaryInsurance.isValid}
            errorMsg={errorMessage?.inputErrorMessage}
            onChangeField={onChangeField}
            Maxlength='200'
          />
        </div>}
      </div>
    </React.Fragment>
  );
}

export default Insurance;
